/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Error_CourseInputs */

const en_player_error_course = /** @type {(inputs: Player_Error_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading course`)
};

const ja_player_error_course = /** @type {(inputs: Player_Error_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースの読み込みエラー`)
};

const fr_player_error_course = /** @type {(inputs: Player_Error_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement du cours`)
};

const de_player_error_course = /** @type {(inputs: Player_Error_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden des Kurses`)
};

/**
* | output |
* | --- |
* | "Error loading course" |
*
* @param {Player_Error_CourseInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_error_course = /** @type {((inputs?: Player_Error_CourseInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Error_CourseInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_error_course(inputs)
	if (locale === "ja") return ja_player_error_course(inputs)
	if (locale === "fr") return fr_player_error_course(inputs)
	return de_player_error_course(inputs)
});